export default __webpack_public_path__ + "static/media/lic.e3180cc0.png";